import React from "react";
import PropTypes from "prop-types";
import TimeOfDay from "./TimeOfDay.jsx";
import SectionItem from "./SectionItem.jsx";
import AudioFile from "./AudioFile.jsx";

const destinationType = [
  "",
  "Number",
  "SIP",
  "Agent",
  "Site",
  "Hosted Number",
  "Hosted Group",
  "Hosted Licence",
  "MS Teams",
  "Flow User",
  "Flow Group",
  "Contact",
];

export default class DestinationGroup extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  formatFunction = (key) => {
    switch (key) {
      case "LIST":
        return this.formatList;
      case "MULTI_CALL":
        return this.formatMultiCall;
      case "RATIO":
        return this.formatRatio;
      case "ROUND_ROBIN":
        return this.formatRoundRobin;
      case "AUDIO_PLAYBACK":
        return this.formatAudioPlayback;
      default:
        return this.formatDefault;
    }
  };

  componentDidMount = () => {
    this.loadHostedGroups();
    this.loadHostedLicences();
    this.loadMsTeamsLicences();
    this.loadFlowUsers();
    this.loadFlowGroups();
    this.loadContacts();
  };

  loadHostedGroups = () => {
    if (window.top.hostedGroups && window.top.hostedGroups.length > 0) {
      this.setState({ hostedGroups: window.top.hostedGroups });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;

          fetch(`/nm-api/api/hosted/account/${this.props.clientId}/groups`, {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${authData.jwt}`,
            },
            method: "GET",
            cache: "no-cache",
            signal: this.abortController.signal,
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ hostedGroups: res.data });
            });
        });
    }
  };

  loadHostedLicences = () => {
    if (window.top.hostedLicences && window.top.hostedLicences.length > 0) {
      this.setState({ hostedLicences: window.top.hostedLicences });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;

          fetch(`/nm-api/api/hosted/account/${this.props.clientId}/licences`, {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${authData.jwt}`,
            },
            method: "GET",
            cache: "no-cache",
            signal: this.abortController.signal,
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ hostedLicences: res.data });
            });
        });
    }
  };

  loadMsTeamsLicences = () => {
    if (
      window.top.msTeamsDestinations &&
      window.top.msTeamsDestinations.length > 0
    ) {
      this.setState({ msTeamsDestinations: window.top.msTeamsDestinations });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;
          const apiUrl = document.getElementById("apiUrl").value;

          fetch(`${apiUrl}/accounts/${this.props.clientId}/teams_users`, {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${authData.jwt}`,
            },
            method: "GET",
            cache: "no-cache",
            signal: this.abortController.signal,
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ msTeamsDestinations: res });
            });
        });
    }
  };

  loadFlowUsers = () => {
    if (window.top.flowDestinations && window.top.flowDestinations.length > 0) {
      this.setState({ flowDestinations: window.top.flowDestinations });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;
          const apiUrl = document.getElementById("apiUrl").value;

          fetch(
            `${apiUrl}/accounts/${this.props.clientId}/shared_destinations?typeId=9`,
            {
              headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${authData.jwt}`,
              },
              method: "GET",
              cache: "no-cache",
              signal: this.abortController.signal,
            },
          )
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ flowDestinations: res });
            });
        });
    }
  };

  loadFlowGroups = () => {
    if (
      window.top.flowGroupDestinations &&
      window.top.flowGroupDestinations.length > 0
    ) {
      this.setState({
        flowGroupDestinations: window.top.flowGroupDestinations,
      });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;
          const apiUrl = document.getElementById("apiUrl").value;

          fetch(
            `${apiUrl}/accounts/${this.props.clientId}/shared_destination_groups?type=flowgroup`,
            {
              headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${authData.jwt}`,
              },
              method: "GET",
              cache: "no-cache",
              signal: this.abortController.signal,
            },
          )
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ flowGroupDestinations: res });
            });
        });
    }
  };

  loadContacts = () => {
    if (
      window.top.contactDestinations &&
      window.top.contactDestinations.length > 0
    ) {
      this.setState({ contacts: window.top.contactDestinations });
    } else {
      fetch(`/getToken`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((resp) => {
          const authData = resp.response;
          const apiUrl = document.getElementById("apiUrl").value;

          fetch(
            `${apiUrl}/accounts/${this.props.clientId}/shared_destinations?typeId=11`,
            {
              headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${authData.jwt}`,
              },
              method: "GET",
              cache: "no-cache",
              signal: this.abortController.signal,
            },
          )
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .then((res) => {
              this.setState({ contacts: res });
            });
        });
    }
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  getGroupName = (groupId) => {
    if (this.state.hostedGroups) {
      const group = this.state.hostedGroups.find((grp) => grp.id === groupId);
      return group ? group.name : "Unknown Group";
    }
    return "Fetching Groups";
  };

  getLicenceName = (licenceId) => {
    if (this.state.hostedLicences) {
      const licence = this.state.hostedLicences.find(
        (lic) => lic.id === licenceId,
      );
      return licence ? licence.name : "Unknown Licence";
    }
    return "Fetching Licences";
  };

  getMSTeamsName = (msTeamsId) => {
    if (this.state.msTeamsDestinations) {
      const teamsDest = this.state.msTeamsDestinations.find(
        (lic) => `${lic.msTeamsUserid}` === msTeamsId,
      );
      return teamsDest ? teamsDest.name : "Unknown Teams Destination";
    }
    return "Fetching MS Teams Destinations";
  };

  getFlowUserName = (flowId) => {
    if (this.state.flowDestinations) {
      const flowUser = this.state.flowDestinations.find(
        (lic) => `${lic.uuid}` === `${flowId}`,
      );
      return flowUser ? flowUser.displayName : "Unknown Flow User";
    }
    return "Fetching Flow Users";
  };

  getFlowGroupName = (flowGroupId) => {
    if (this.state.flowGroupDestinations) {
      const flowGroup = this.state.flowGroupDestinations.find(
        (lic) => `${lic.id}` === `${flowGroupId}`,
      );
      return flowGroup ? flowGroup.name : "Unknown Flow Group";
    }
    return "Fetching Flow Groups";
  };

  getContactName = (contactId) => {
    if (this.state.contacts) {
      const contact = this.state.contacts.find(
        (lic) => `${lic.uuid}` === `${contactId}`,
      );
      return contact ? contact.displayName : "Unknown Contact";
    }
    return "Fetching Contacts";
  };

  getSite = (destination, siteId) => {
    if (siteId && this.props.sites.find((s) => s.id === siteId)) {
      return this.props.sites
        .filter((s) => s.id === siteId)
        .map((site, i) => (
          <span key={i}>
            {destination} ({site.name}){" "}
          </span>
        ));
    }
    return <span>Site not found</span>;
  };

  formatTable = (destinationList, includeRatio) => {
    return (
      <table width="50%">
        <thead>
          <tr>
            <th>Type</th>
            <th>Destination</th>
            <th>Ringing</th>
            {includeRatio ? <th>Ratio</th> : null}
          </tr>
        </thead>
        <tbody>
          {destinationList.map((dest, i) => {
            let destinationDisplay = dest.destination;
            switch (Number(`${dest.destinationType}`)) {
              case 3:
                destinationDisplay = dest.agentProfileName;
                break;
              case 4:
                destinationDisplay = this.getSite(
                  dest.destination,
                  dest.siteId,
                );
                break;
              case 5:
                destinationDisplay =
                  destinationDisplay.indexOf("@") > -1
                    ? destinationDisplay.substring(
                        0,
                        destinationDisplay.indexOf("@"),
                      )
                    : destinationDisplay;
                break;
              case 6:
                destinationDisplay = this.getGroupName(dest.hostedGroupId);
                break;
              case 7:
                destinationDisplay = this.getLicenceName(dest.hostedLicenceId);
                break;
              case 8:
                destinationDisplay = this.getMSTeamsName(dest.msTeamsId);
                break;
              case 9:
                destinationDisplay = this.getFlowUserName(dest.flowId);
                break;
              case 10:
                destinationDisplay = this.getFlowGroupName(dest.flowGroupId);
                break;
              case 11:
                destinationDisplay = this.getContactName(dest.contactId);
                break;
              default:
                break;
            }
            return (
              <tr
                className={i % 2 > 0 ? "alt" : ""}
                key={`${dest.destination}_${i}`}
              >
                <td key={`type${i}`}>
                  {destinationType[dest.destinationType]}
                </td>
                <td key={`dest${i}`}>{destinationDisplay}</td>
                <td key={`timeout${i}`}>{dest.ringTimeout}</td>
                {includeRatio ? <td key={`ratio${i}`}>{dest.ratio}</td> : null}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  formatDefault = (destinationGroup) => {
    return this.formatTable(destinationGroup.destinationList, false);
  };

  formatList = (destinationGroup) => {
    return (
      <span>
        <SectionItem itemKey="Call Type">Call in List Order</SectionItem>
        <SectionItem itemKey="Configured Destinations" wrapped={true}>
          {this.formatTable(destinationGroup.destinationList, false)}
        </SectionItem>
        <SectionItem itemKey="Availability">
          {destinationGroup.todPreset ? (
            <TimeOfDay todId={destinationGroup.todPreset} />
          ) : (
            "Time Of Day Not Set"
          )}
        </SectionItem>
      </span>
    );
  };

  formatMultiCall = (destinationGroup) => {
    return (
      <span>
        <SectionItem itemKey="Call Type">Call all at Once</SectionItem>
        <SectionItem wrapped itemKey="Configured Destinations">
          {this.formatTable(destinationGroup.destinationList, false)}
        </SectionItem>
        <SectionItem itemKey="Availability">
          {destinationGroup.todPreset ? (
            <TimeOfDay todId={destinationGroup.todPreset} />
          ) : (
            "Time Of Day Not Set"
          )}
        </SectionItem>
      </span>
    );
  };

  formatRatio = (destinationGroup) => {
    return (
      <span>
        <SectionItem itemKey="Call Type">Ratio Plan</SectionItem>
        <SectionItem wrapped itemKey="Configured Destinations">
          {this.formatTable(destinationGroup.destinationList, true)}
        </SectionItem>
        <SectionItem itemKey="Availability">
          {destinationGroup.todPreset ? (
            <TimeOfDay todId={destinationGroup.todPreset} />
          ) : (
            "Time Of Day Not Set"
          )}
        </SectionItem>
      </span>
    );
  };

  formatRoundRobin = (destinationGroup) => {
    return (
      <span>
        <SectionItem itemKey="Call Type">Round Robin</SectionItem>
        <SectionItem wrapped itemKey="Configured Destinations">
          {this.formatTable(destinationGroup.destinationList, false)}
        </SectionItem>
        <SectionItem itemKey="Availability">
          {destinationGroup.todPreset ? (
            <TimeOfDay todId={destinationGroup.todPreset} />
          ) : (
            "Time Of Day Not Set"
          )}
        </SectionItem>
      </span>
    );
  };

  formatAudioPlayback = (destinationGroup) => {
    return (
      <span>
        <SectionItem itemKey="Call Type">Audio Playback</SectionItem>
        <SectionItem itemKey="Audio File">
          <AudioFile audioId={destinationGroup.audio} />
        </SectionItem>
        <SectionItem itemKey="">
          {destinationGroup.audioRepeats === 1
            ? "Hang up after audio plays"
            : "Audio repeats"}
        </SectionItem>
        <SectionItem itemKey="Availability">
          {destinationGroup.todPreset ? (
            <TimeOfDay todId={destinationGroup.todPreset} />
          ) : (
            "Time Of Day Not Set"
          )}
        </SectionItem>
      </span>
    );
  };

  render = () => {
    const displayObject = this.formatFunction(this.props.group.callType);
    return <span>{displayObject(this.props.group)}</span>;
  };
}

DestinationGroup.propTypes = {
  group: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
